/**
 * Servicio que se encarga del manejo de las peticiones sobre las
 * acciones "Crear, Modificar y Eliminar" de Marcas.
 * JMM-2018-06-20
 */
import { Injectable } from '@angular/core';
import { Http, Response } from '@angular/http';
import { ConfigService } from '../../servicios/config/config.service';
import { KeyService } from '../../servicios/key.service';

@Injectable()
export class FichasTecnicasService {

  public marcas : any[] = [];
  PATH = new ConfigService().obtenerPath();

  constructor(
    private http  : Http,
    private _key  : KeyService
  ) {}


    /**
   * Obtener el listado de registros
   * JMM-2018-07-25
   */
  getarchivo(pqrid)
  {
      let url = this.PATH + '/api/public/listnotadetallepqr/'+pqrid;
      return this.http.get(url, {headers:this._key.head()}).map(resp => resp.json());
  }// .getNotaDetallePqr(pqrid)

    /**
   * Obtener el listado de archivos de las fichas tecnicas
   * CESAR-2019-04-08
   */
  getArchivofichatecnicas(itemequipoid)
  {
      let url = this.PATH + '/api/public/listArchivoFichasTecnicas/'+itemequipoid;
      return this.http.get(url, {headers:this._key.head()}).map(resp => resp.json());
  }// .getArchivofichatecnicas(pqrid)


      /**
   * Obtener el listado de archivos de las fichas tecnicas
   * CESAR-2019-04-08
   */
  getActividadesEquipofichatecnicas(idequipoid)
  {
      let url = this.PATH + '/api/public/listActividadesEquipoFichasTecnicas/'+idequipoid;
      return this.http.get(url, {headers:this._key.head()}).map(resp => resp.json());
  }// .getArchivofichatecnicas(pqrid)



    /**
   * Enviar registros de fichas maquinas y equipo
   * CESAR ARIAS-2019-04-11
   */
  setMaquinaEquipo(dataMaquinaEquipo:any)
  {
      let url = this.PATH + '/api/public/crearFichaMaquinaEquipo';
      return this.http.post(url, dataMaquinaEquipo, {headers:this._key.head()}).map(resp => resp.json());
  }// .setMaquinaEquipo(ans:any)

     /**
   * valida si el itemequipo esta creado en la ficha de maquinaria y equipo
   * CESAR-2019-04-10
   */
  validarexistmaquinaria(itemequipoid)
  {
      let url = this.PATH + '/api/public/validarexistmaquinaria/'+itemequipoid;
      return this.http.get(url, {headers:this._key.head()}).map(resp => resp.json());
  }// .validarexistmaquinaria(pqrid)

  /**
   * Enviar registro para eliminar en bd maquinaria de las fichas tecnicas
   * CESAR ARIAS-2019-04-11
   */
  destroyMaquinaria(maquinariaid:any,itemequipoid:any)
  {
      let url = this.PATH + '/api/public/destroyMaquinaria/'+maquinariaid+'/'+itemequipoid+'/destroyMaquinaria';
      return this.http.get(url, {headers:this._key.head()}).map(resp => resp.json());
  }// .destroyMaquinaria(destroyMaquinaria:any)

  /**
   * Enviar registro para eliminar en bd vehiculo de las fichas tecnicas
   * CESAR ARIAS-2019-04-11
   */
  destroyVehiculo(vehiculoid:any,itemequipoid:any)
  {
      let url = this.PATH + '/api/public/destroyVehiculo/'+vehiculoid+'/'+itemequipoid+'/destroyVehiculo';
      return this.http.get(url, {headers:this._key.head()}).map(resp => resp.json());
  }// .destroyVehiculo(destroyVehiculo:any)

   /**
   * valida si el itemequipo esta creado en la ficha de maquinaria y equipo
   * CESAR-2019-04-10
   */
  validarExistVehiculo(itemequipoid)
  {
      let url = this.PATH + '/api/public/validarExistVehiculo/'+itemequipoid;
      return this.http.get(url, {headers:this._key.head()}).map(resp => resp.json());
  }// .validarexistmaquinaria(pqrid)


  /**
   * edita registros de fichas maquinas y equipo
   * CESAR ARIAS-2019-04-11
   */
  updateMaquinaria(dataEditMaquinaEquipo:any)
  {
      let url = this.PATH + '/api/public/updateMaquinaria';
      return this.http.post(url, dataEditMaquinaEquipo, {headers:this._key.head()}).map(resp => resp.json());
  }// .setMaquinaEquipo(ans:any)

  /**
   * edita registros de fichas vehiculo equipo
   * CESAR ARIAS-2019-04-19
   */
  updateVehiculo(dataEditVehiculo:any)
  {
    console.log(dataEditVehiculo);
      let url = this.PATH + '/api/public/updateVehiculo';
      return this.http.post(url, dataEditVehiculo, {headers:this._key.head()}).map(resp => resp.json());
  }// .updateVehiculo(ans:any)


  /**
   * Enviar registro para guardarlo en bd archivos de las fichas tecnicas
   * CESAR ARIAS-2019-04-11
   */
  setArchivoFicha(archivoFichaTecnica:any)
  {
      let url = this.PATH + '/api/public/archivoFichaTecnica';
      return this.http.post(url, archivoFichaTecnica, {headers:this._key.head()}).map(resp => resp.json());
  }// .setArchivoFicha(setArchivoFicha:any)

   /**
   * Enviar registro para guardarlo en bd archivos de las fichas tecnicas
   * CESAR ARIAS-2019-04-11
   */
  destroyArchivo(documentofichaid:any)
  {
      let url = this.PATH + '/api/public/archivoFichaTecnica/'+documentofichaid+'/destroyArchivo';
      return this.http.get(url, {headers:this._key.head()}).map(resp => resp.json());
  }// .destroyArchivo(destroyArchivo:any)

    /**
   * Enviar registro para guardarlo en bd operaciones de tiempo y consumo de las fichas tecnicas
   * CESAR ARIAS-2019-04-11
   */
  creaOperacionesFichaTecnicas(operacionesFichaTecnica:any)
  {
      let url = this.PATH + '/api/public/creaOperacionesFichaTecnicas';
      return this.http.post(url, operacionesFichaTecnica, {headers:this._key.head()}).map(resp => resp.json());
  }// .setOperacionesFichaTecnicas(operacionesFichaTecnica:any)


   /**
   * Enviar registros de fichas maquinas y equipo
   * CESAR ARIAS-2019-04-11
   */
  setVehiculoEquipo(dataMaquinaEquipo:any)
  {
      let url = this.PATH + '/api/public/crearFichaVehiculo';
      return this.http.post(url, dataMaquinaEquipo, {headers:this._key.head()}).map(resp => resp.json());
  }// .setMaquinaEquipo(ans:any)

   /**
   * Enviar registros elemento  de fichas vehiculo
   * CESAR ARIAS-2019-04-11
   */
  setElementovehiculo(dataElemento:any)
  {
      let url = this.PATH + '/api/public/crearElementoVehiculo';
      return this.http.post(url, dataElemento, {headers:this._key.head()}).map(resp => resp.json());
  }// .setMaquinaEquipo(ans:any)

    /**
   * Obtener el listado de elemento de las fichas tecnicas vehiculo
   * CESAR-2019-04-08
   */
  listarElementoVehiculo(vehiculoid)
  {
      let url = this.PATH + '/api/public/listarElementoVehiculo/'+vehiculoid;
      return this.http.get(url, {headers:this._key.head()}).map(resp => resp.json());
  }// .listarElementoVehiculo(pqrid)

   /**
   * Obtener el listado de elemento de las fichas tecnicas vehiculo
   * CESAR-2019-04-08
   */
  listFichaVehiculo(data)
  {
        let url = this.PATH + '/api/public/listFichaVehiculo';
        return this.http.post(url,data, {headers:this._key.head()}).map(resp => resp.json());
  }//.listFichaVehiculo()

     /**
   * Obtener el listado de elemento de las fichas tecnicas vehiculo
   * CESAR-2019-04-08
   */
  listFichaComputo(data)
  {
      let url = this.PATH + '/api/public/listFichaComputo';
      return this.http.post(url,data, {headers:this._key.head()}).map(resp => resp.json());
  }

     /**
   * Obtener el listado de elemento de las fichas tecnicas maquinaria
   * CESAR-2019-04-08
   */
  listFichamaquinaria(data)
  {
      let url = this.PATH + '/api/public/listFichamaquinaria';
      return this.http.post(url, data,{headers:this._key.head()}).map(resp => resp.json());
  }//.listFichamaquinaria()

  /**
   * Obtener el listado de elemento de las fichas tecnicas locativa
   * CESAR-2019-04-08
   */
  listFichaLocativa(data)
  {
      let url = this.PATH + '/api/public/listFichaLocativa';
      return this.http.post(url,data, {headers:this._key.head()}).map(resp => resp.json());
  }

    /**
   * edita registros de fichas maquinas y equipo
   * CESAR ARIAS-2019-04-11
   */
  updateElementoVehiculo(dataElementoVehiculo:any)
  {
      let url = this.PATH + '/api/public/updateElementoVehiculo';
      return this.http.post(url, dataElementoVehiculo, {headers:this._key.head()}).map(resp => resp.json());
  }// .setMaquinaEquipo(ans:any)

  /**
   * Enviar registro para eliminar en bd archivos de las fichas tecnicas
   * CESAR ARIAS-2019-04-11
   */
  destroyElemento(elementovehiculoid:any)
  {
      let url = this.PATH + '/api/public/archivoFichaTecnica/'+elementovehiculoid+'/destroyElemento';
      return this.http.get(url, {headers:this._key.head()}).map(resp => resp.json());
  }// .destroyArchivo(destroyArchivo:any)

     /**
   * Enviar registros propietario o conductor  de fichas vehiculo
   * CESAR ARIAS-2019-04-22
   */
  setPersonalVehiculo(dataPeCo:any)
  {
      let url = this.PATH + '/api/public/crearPersonalVehiculo';
      return this.http.post(url, dataPeCo, {headers:this._key.head()}).map(resp => resp.json());
  }// .setPropietarioConducvehiculo(ans:any)


   /**
   * Obtener el listado de personal vehiculo
   * CESAR-2019-04-22
   */
  listarPersonalVehiculo(vehiculoid)
  {
      let url = this.PATH + '/api/public/listarPersonalVehiculo/'+vehiculoid;
      return this.http.get(url, {headers:this._key.head()}).map(resp => resp.json());
  }// .listarPersonalVehiculo(pqrid)

   /**
   * edita registros de fichas personal vehiculo
   * CESAR ARIAS-2019-04-11
   */
  updatepersonalVehiculo(dataPersonalVehiculo:any)
  {
      let url = this.PATH + '/api/public/updatepersonalVehiculo';
      return this.http.post(url, dataPersonalVehiculo, {headers:this._key.head()}).map(resp => resp.json());
  }// .setMaquinaEquipo(ans:any)

   /**
   * Enviar registro para eliminar en bd personal vehiculo de las fichas vehiculo
   * CESAR ARIAS-2019-04-23
   */
  destroyPersonalVehiculo(personalvehiculoid:any)
  {
      let url = this.PATH + '/api/public/archivoFichaTecnica/'+personalvehiculoid+'/destroyPersonalVehiculo';
      return this.http.get(url, {headers:this._key.head()}).map(resp => resp.json());
  }// .destroyPersonalVehiculo(destroyPersonalVehiculo:any)

  //COMPUTO
   /**
   * valida si el itemequipo esta creado en la ficha de maquinaria y equipo
   * CESAR-2019-04-10
   */
  validarExistComputo(itemequipoid)
  {
      let url = this.PATH + '/api/public/validarExistComputo/'+itemequipoid;
      return this.http.get(url, {headers:this._key.head()}).map(resp => resp.json());
  }// .validarexistmaquinaria(pqrid)

   /**
   * Enviar registros de fichas computo
   * CESAR ARIAS-2019-04-11
   */
  setComputo(dataComputo:any)
  {
      let url = this.PATH + '/api/public/crearFichaComputo';
      return this.http.post(url, dataComputo, {headers:this._key.head()}).map(resp => resp.json());
  }// .setMaquinaEquipo(ans:any)

   /**
   * edita registros de fichas vehiculo equipo
   * CESAR ARIAS-2019-04-19
   */
  updateComputo(dataEditVehiculo:any)
  {
      let url = this.PATH + '/api/public/updateComputo';
      return this.http.post(url, dataEditVehiculo, {headers:this._key.head()}).map(resp => resp.json());
  }// .updateVehiculo(ans:any)

   /**
   * Enviar registros hardware  de fichas vehiculo
   * CESAR ARIAS-2019-04-11
   */
  setHardwareEquipo(dataElemento:any)
  {
      let url = this.PATH + '/api/public/crearhardwareEquipo';
      return this.http.post(url, dataElemento, {headers:this._key.head()}).map(resp => resp.json());
  }// .setHardwareEquipo(ans:any)

  /**
   * Obtener el listado de  equipocomputoid hardware
   * CESAR-2019-04-22
   */
  listarEquipohardware(equipocomputoid)
  {
      let url = this.PATH + '/api/public/listarEquipohardware/'+equipocomputoid;
      return this.http.get(url, {headers:this._key.head()}).map(resp => resp.json());
  }// .listarPersonalVehiculo(pqrid)

  /**
   * edita registros de fichas computo hardware equipo
   * CESAR ARIAS-2019-04-25
   */
  updateHardwareEquipo(dataHardware:any)
  {
      let url = this.PATH + '/api/public/updateHardwareEquipo';
      return this.http.post(url, dataHardware, {headers:this._key.head()}).map(resp => resp.json());
  }// .setMaquinaEquipo(ans:any)

   /**
   * Enviar registro para eliminar en bd registro de hardware equipo de las fichas computo
   * CESAR ARIAS-2019-04-25
   */
  destroyHardwareEquipo(hardwareequipoid:any)
  {
      let url = this.PATH + '/api/public/destroyHardwareEquipo/'+hardwareequipoid+'/destroyHardwareEquipo';
      return this.http.get(url, {headers:this._key.head()}).map(resp => resp.json());
  }// .destroyHardwareEquipo(destroyHardwareEquipo:any)

   /**
   * Enviar registros Softwareequipo  de fichas vehiculo
   * CESAR ARIAS-2019-04-11
   */
  setSoftwareEquipo(dataSoftware:any)
  {
      let url = this.PATH + '/api/public/crearSoftwareEquipo';
      return this.http.post(url, dataSoftware, {headers:this._key.head()}).map(resp => resp.json());
  }// .setSoftwareEquipo(ans:any)

     /**
   * Obtener el listado de  equipocomputoid hardware
   * CESAR-2019-04-22
   */
  listarEquiposoftware(equipocomputoid)
  {
      let url = this.PATH + '/api/public/listarEquiposoftware/'+equipocomputoid;
      return this.http.get(url, {headers:this._key.head()}).map(resp => resp.json());
  }// .listarPersonalVehiculo(pqrid)

   /**
   * edita registros de fichas computo software equipo
   * CESAR ARIAS-2019-04-25
   */
  updateSoftwareEquipo(dataHardware:any)
  {
      let url = this.PATH + '/api/public/updateSoftwareEquipo';
      return this.http.post(url, dataHardware, {headers:this._key.head()}).map(resp => resp.json());
  }// .updateSoftwareEquipo(ans:any)

    /**
   * Enviar registro para eliminar en bd registro de hardware equipo de las fichas computo
   * CESAR ARIAS-2019-04-25
   */
  destroySoftwareEquipo(softwareequipoid:any)
  {
      let url = this.PATH + '/api/public/destroySoftwareEquipo/'+softwareequipoid+'/destroySoftwareEquipo';
      return this.http.get(url, {headers:this._key.head()}).map(resp => resp.json());
  }// .destroySoftwareEquipo(destroySoftwareEquipo:any)

   /**
   * Enviar registro para eliminar en bd maquinaria de las fichas tecnicas
   * CESAR ARIAS-2019-04-11
   */
  destroyComputo(equipocomputoid:any,itemequipoid:any)
  {
      let url = this.PATH + '/api/public/destroyComputo/'+equipocomputoid+'/'+itemequipoid+'/destroyComputo';
      return this.http.get(url, {headers:this._key.head()}).map(resp => resp.json());
  }// .destroyMaquinaria(destroyMaquinaria:any)

   /**
   * lista operaciones de tiempo y consumo
   * CESAR ARIAS-2019-04-29
   */
  listarOperaciones($itemequipoid){
      let url = this.PATH  + '/api/public/listarOperaciones'+ $itemequipoid;
      return this.http.get(url,{headers:this._key.head()}).map(resp => resp.json());
  }

  /**
   * edita registros de fichas operaciones
   * CESAR ARIAS-2019-04-29
   */
  updateOperacion(dataOperacion:any)
  {
      let url = this.PATH + '/api/public/updateOperacion';
      return this.http.post(url, dataOperacion, {headers:this._key.head()}).map(resp => resp.json());
  }// .updateOperacion(ans:any)


  /**
   * Enviar registro para eliminar en bd operacionid de las fichas tecnicas
   * CESAR ARIAS-2019-04-29
   */
  destroyOperacion(operacionid:any)
  {
      let url = this.PATH + '/api/public/destroyOperacion/'+operacionid+'/destroyOperacion';
      return this.http.get(url, {headers:this._key.head()}).map(resp => resp.json());
  }// .destroyOperacion(destroyOperacion:any)

    /**
   * agrega actividades por defaull a operaciones de tiempo registros de fichas operaciones
   * CESAR ARIAS-2019-04-29
   */
  agregaractividaTiempo(agregaractividaTiempo:any)
  {
      let url = this.PATH + '/api/public/agregaractividaTiempo';
      return this.http.post(url, agregaractividaTiempo, {headers:this._key.head()}).map(resp => resp.json());
  }// .agregaractividaTiempo(ans:any)

  /**
   * Enviar registros de fichas locativa
   * CESAR ARIAS-2019-04-11
   */
  setLocativa(dataLocativa:any)
  {
      let url = this.PATH + '/api/public/crearFichaLocativa';
      return this.http.post(url, dataLocativa, {headers:this._key.head()}).map(resp => resp.json());
  }// .setLocativa(ans:any)

   /**
   * valida si el itemequipo esta creado en la ficha de maquinaria y equipo
   * CESAR-2019-04-10
   */
  validarExistLocativa(itemequipoid)
  {
      let url = this.PATH + '/api/public/validarExistLocativa/'+itemequipoid;
      return this.http.get(url, {headers:this._key.head()}).map(resp => resp.json());
  }// .validarexistmaquinaria(pqrid)

   /**
   * Enviar registro para eliminar en bd locativa de las fichas locativa
   * CESAR ARIAS-2019-04-11
   */
  destroyLocativa(locativaid:any,itemequipoid:any)
  {
      let url = this.PATH + '/api/public/destroyLocativa/'+locativaid+'/'+itemequipoid+'/destroyLocativa';
      return this.http.get(url, {headers:this._key.head()}).map(resp => resp.json());
  }// .destroyLocativa(destroyLocativa:any)

   /**
   * edita registros de fichas locativa
   * CESAR ARIAS-2019-04-19
   */
  updateLocativa(dataEditLocativa:any)
  {
      let url = this.PATH + '/api/public/updateLocativa';
      return this.http.post(url, dataEditLocativa, {headers:this._key.head()}).map(resp => resp.json());
  }// .updateLocativa(ans:any)

  /**
   * Obtener el listado del semaforo
   * CESAR-2019-04-08
   */
  consultaOperacion(data){
      let url = this.PATH + '/api/public/consultaOperacion';
      return this.http.post(url,data ,{headers:this._key.head()}).map(resp => resp.json());
  }//.consultaOperacion()


  obtenerOperacionSemaforo(data){
      let url = this.PATH + '/api/public/obtenerOperacionSemaforo';
      return this.http.post(url ,data,{headers:this._key.head()}).map(resp => resp.json());
  }


  obtenerOperacionConsumo(data){
      let url = this.PATH + '/api/public/obtenerOperacionConsumo';
      return this.http.post(url,data ,{headers:this._key.head()}).map(resp => resp.json());
  }


  /**
  *Informe fichas tecnicas
  *tipo = si es locativa l , vehiculo v, computo t , maquinaria m
  * CAAA-2019-11-13
  */
  infoFichaTecnicas($data){
    let filtro = {
       'pqrid'              : $data.pqrid             != '' ? $data.pqrid             : null,
       'estadopqrid'        : $data.estadopqrid       != '' ? $data.estadopqrid       : null,
       'tipopqrid'          : $data.tipopqrid         != '' ? $data.tipopqrid         : null,
       'operacionid'        : $data.operacionid       != '' ? $data.operacionid       : null,
       'tipo'               : $data.tipo              != '' ? $data.tipo              : null,
       'idficha'            : $data.idficha           != '' ? $data.idficha           : null,
       'incconelineainven'  : $data.incconelineainven != '' ? $data.incconelineainven : null,
       'servidorbdinven'    : $data.servidorbdinven   != '' ? $data.servidorbdinven   : null,
       'basedatosinven'     : $data.basedatosinven    != '' ? $data.basedatosinven    : null,
       'usuarioinven'       : $data.usuarioinven      != '' ? $data.usuarioinven      : null,
       'claveinven'         : $data.claveinven        != '' ? $data.claveinven        : null,
       'tipoinventario'     : $data.tipoinventario    != '' ? $data.tipoinventario    : null,
       'fechaini'           : $data.fechaini          != '' ? $data.fechaini          : null,
       'fechafin'           : $data.fechafin          != '' ? $data.fechafin          : null,
    }

      let url = this.PATH + '/api/public/infoFichaTecnicas';
      return this.http.post(url,filtro,{headers:this._key.head()}).map(resp => resp.json());
  }


  public postFileImagen(imagenParaSubir){
      let url = this.PATH + '/api/public/enviararchivo/';
    // let header = new Headers();
    // header.append("Access-Control-Allow-Origin",'*');
    // header.append("Access-Control-Allow-Methods","OPTIONS,POST,GET");
    // header.append("Content-Type","");

    const formData = new FormData();
    // this._key.headers.append("Content-Type",'false');

      formData.append('imagenPropia',imagenParaSubir);

     console.log('formData',formData);

		  return this.http.post(url, formData,{headers:this._key.head()}).map(resp => resp.json());

  }

  /**
  * Obtener datos de productos ERPFive
  * cesar augusto arias arcila
  */
  getproductosInsumos(dataconexion)
  {
      let url = this.PATH + '/api/public/getproductosInsumos';
      return this.http.post(url,dataconexion, {headers:this._key.head()}).map(resp => resp.json());
  }// .getproductosInsumos(productoid:any)

  /**
   * Enviar registro para guardarlo en bd los insumos
   * CESAR ARIAS-2019-04-11
   */
  creaInsumoOperacion(operacionesFichaTecnica:any)
  {
      let url = this.PATH + '/api/public/creaInsumoOperaciones';
      return this.http.post(url, operacionesFichaTecnica, {headers:this._key.head()}).map(resp => resp.json());
  }// .setOperacionesFichaTecnicas(operacionesFichaTecnica:any)


  /**
   * consultar insumos
   * CESAR ARIAS-2020-11-09
   */
  getListInsumos(conexion:any)
  {
      let url = this.PATH + '/api/public/getListInsumos';
      return this.http.post(url, conexion, {headers:this._key.head()}).map(resp => resp.json());
  }// .setOperacionesFichaTecnicas(operacionesFichaTecnica:any)


    /**
   * edita registros de fichas operaciones
   * CESAR ARIAS-2019-04-29
   */
  updateInsumoOperacion(dataInsumoOperacion:any)
  {
      let url = this.PATH + '/api/public/updateInsumoOperacion';
      return this.http.post(url, dataInsumoOperacion, {headers:this._key.head()}).map(resp => resp.json());
  }// .updateOperacion(ans:any)


  destroyInsumOperacion(insumooperacionid:any)
  {
      let url = this.PATH + '/api/public/destroyInsumOperacion/'+insumooperacionid+'/destroyInsumOperacion';
      return this.http.get(url, {headers:this._key.head()}).map(resp => resp.json());
  }// .destroyLocativa(destroyLocativa:any)


  enviarCantConsumo(dataConsumoOperacion:any)
  {
      let url = this.PATH + '/api/public/enviarCantConsumo';
      return this.http.post(url, dataConsumoOperacion, {headers:this._key.head()}).map(resp => resp.json());
  }// .updateOperacion(ans:any)


  datosfiltrosSemaforoOp()
  {
      let url = this.PATH + '/api/public/datosfiltrosSemaforoOp';
      return this.http.get(url, {headers:this._key.head()}).map(resp => resp.json());
  }// .updateOperacion(ans:any)


  costoProveedoranioFicha(data:any)
  {
      let url = this.PATH + '/api/public/costoProveedoranioFicha';
      return this.http.post(url, data, {headers:this._key.head()}).map(resp => resp.json());
  }// .updateOperacion(ans:any)

  // set nuevaFicha()
  setDataFicha(data,seturl){
    let url = this.PATH + '/api/public/'+seturl;
    return this.http.post(url, data, {headers:this._key.head()}).map(resp => resp.json());
  }

  getitemEquio(tipoficha,itemequipoid){
      let url = this.PATH + '/api/public/listItemquipofichas/'+tipoficha+'/'+itemequipoid;
      return this.http.get(url, {headers:this._key.head()}).map(resp => resp.json());
  }

}



// WEBPACK FOOTER //
// E:/xampp/htdocs/liberado/CocoraSMFront/src/app/servicios/fichas-tecnicas/fichas-tecnicas.service.ts